import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import SliderCore from "@/components/SliderCore";
import isOuterAreaClick from "@/lib/isOuterAreaClick";
import styles from "@/styles/LightBox.module.scss";
import { clearAllBodyScrollLocks, disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import classnames from "classnames";
import Image from "next/legacy/image";
import { useCallback, useEffect, useRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IconClose = function IconClose(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      width: "48",
      height: "48",
      fill: "rgba(255,255,255,0)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12,11.293,22.293,1,23,1.707,12.707,12,23,22.293,22.293,23,12,12.707,1.707,23,1,22.293,11.293,12,1,1.707,1.707,1Z",
      transform: "translate(12 12)",
      fill: "#909090",
      fillRule: "evenodd"
    })]
  }));
};
IconClose.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 48 48"
};
const sliderOptions = {
  slidesPerView: 1,
  slidesPerGroup: 1,
  navigation: true,
  effect: "fade"
};
export default function LightBox(_ref) {
  let {
    show,
    images = [],
    onClose
  } = _ref;
  if (!images || images.length === 0) return null;
  if (images.length === 1) {
    sliderOptions.navigation = false;
  } else {
    sliderOptions.navigation = true;
  }
  const screen = useRef();
  const content = useRef();
  const onScreenClick = useCallback(e => {
    if (isOuterAreaClick(content.current, e)) {
      if (typeof onClose === "function") onClose(e);
      enableBodyScroll(screen.current);
    }
  }, [content.current, onClose]);
  useEffect(() => {
    if (show) {
      disableBodyScroll(screen.current);
    }
    return () => {
      clearAllBodyScrollLocks();
    };
  }, [show]);
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.container, {
      [styles.show]: show
    }),
    ref: screen,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      onClick: onScreenClick,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.navigation,
        children: /*#__PURE__*/_jsx("button", {
          className: styles.close,
          tabIndex: "0",
          role: "button",
          children: /*#__PURE__*/_jsx(IconClose, {})
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.sliderWrapper,
        children: images && /*#__PURE__*/_jsx(SliderCore, {
          sliderOptions: sliderOptions,
          children: images.map((image, i) => /*#__PURE__*/_jsx("div", {
            className: styles.item,
            children: /*#__PURE__*/_jsx("div", {
              className: styles.image,
              ref: content,
              children: !!image && /*#__PURE__*/_jsx(Image, {
                src: image,
                width: 320,
                height: 180,
                layout: "responsive",
                objectFit: "contain"
              })
            })
          }, `lightbox-item-${i}`))
        })
      })]
    })
  });
}